import {Component, DoCheck, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {DragulaService} from 'ng2-dragula';
import {NzMessageService} from 'ng-zorro-antd';

@Component({
    selector: 'ecp-dragula',
    templateUrl: './dragula.component.html',
    styleUrls: ['./dragula.component.css']
})
export class DragulaComponent implements OnInit, DoCheck {
    @Input() fieldObj;
    @Output() event: EventEmitter<any> = new EventEmitter();

    /*    ngOnInit(): void {
            let self = this;
              self.fieldObj = [
                       {label: 'æå±åºå', value: 'communityname', checked: true},
                       {label: 'ä¸ä¸»ç¼å·', value: 'userno'},
                       {label: 'ä¸ä¸»åç§°', value: 'username'},
                       {label: 'çµè¯', value: 'userphone'},
                       {label: 'æ¶è´¹ç§ç±»', value: 'paytypename'},
                       {label: 'ç¨æ°´åå', value: 'reducename'},
                       {label: 'æ°´è¡¨ç¨é', value: 'purposename'},
                       {label: 'æ°´è¡¨ç¼å·', value: 'devno'},
                       {label: 'è´¦æ·ä½é¢(å)', value: 'alreadypay'},
                       {label: 'ç¶æ', value: 'status'},
                       {label: 'åå»ºæ¶é´', value: 'createtime'},

                   ];
        }*/

    toSave() {
        const self = this;
        let selectArry = [];
        self.many2.forEach(function (item, index) {
            let obj = {};
            for (let i = 0; i < self.fieldObj.length; i++) {
                if (self.fieldObj[i].label == self.many2[index]) {
                    obj['name'] = self.fieldObj[i].label;
                    obj['key'] = self.fieldObj[i].value;

                    selectArry.push(obj);
                }
            }


        });

        console.log('////////////////selectArry', selectArry);
        self.event.emit(selectArry);
    }


    MANY_ITEMS = 'MANY_ITEMS';
    public many = [];
    public many2 = [];
    public manyTemp = [];
    public many2Temp = [];

    subs = new Subscription();

    public constructor(private message: NzMessageService, private dragulaService: DragulaService) {
        this.subs.add(dragulaService.dropModel(this.MANY_ITEMS)
            .subscribe(({el, target, source, sourceModel, targetModel, item}) => {
                /* console.log('dropModel:');
                 console.log(el);
                 console.log(source);
                 console.log(target);
                 console.log(sourceModel);
                 console.log(targetModel);
                 console.log(item);*/
            })
        );
        this.subs.add(dragulaService.removeModel(this.MANY_ITEMS)
            .subscribe(({el, source, item, sourceModel}) => {
                /* console.log('removeModel:');
                 console.log(el);
                 console.log(source);
                 console.log(sourceModel);
                 console.log(item);*/
            })
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();

    }

    ngOnChanges() {
        this.init();

    }

    ngOnInit() {
        //    this.init();

    }

    ngDoCheck(): void {
        this.toSave();


    }

    init() {
        const self = this;
        self.manyTemp = [];
        self.many2Temp = [];

        self.fieldObj.forEach(function (item, index) {
            if (self.fieldObj[index].checked == true) {
                self.many2.push(self.fieldObj[index].label);
                self.many2Temp.push(self.fieldObj[index].label);
            } else {
                self.many.push(self.fieldObj[index].label);
                self.manyTemp.push(self.fieldObj[index].label);
            }

        });

    }

    selAll() {
        const self = this;

        self.many.forEach(function (item, index) {
            self.many2.push(self.many[index]);
        });
        self.many = [];

    }


    clear() {
        const self = this;

        self.many = [];
        self.many2 = [];

        self.manyTemp.forEach(function (item, index) {
            self.many.push(item);
        });

        self.many2Temp.forEach(function (item, index) {
            self.many2.push(item);
        });
    }
}
